//import Swiper from 'swiper';
import ScrollTrigger from '@terwanerik/scrolltrigger';
import Swiper from 'swiper/bundle';
import 'swiper/css';
import easing from 'jquery.easing';


export class App {
  constructor(){

    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('page');
    this.ua = isSp(this);
    this.sp = 900;
    this.ease = "easeInOutExpo";


    function isSp(_t){
    let _ua;
    if(navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)){
      _ua = "mobile";
      _t.makeSp();
      //console.log(_t);
    }else{
      _ua = "other";
    }
    _t.body.classList.add(_ua);
    return _ua;
  }
  }
  init(){
    window.addEventListener('load', e => {
      const _this = this;
      setTimeout(() => {
        this.trigger();
        this.html.classList.add('on');
        this.page.classList.add('on');
        $('.spinner').fadeOut('slow',function(){
          $(this).remove();
        });

        this.events();
      },500);
    });
  }
  makeSp(){

  }
  events(){

    if(this.body.classList.contains('home')){

    }
  }

  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {

          },
          out:(trigger) => {

          }
        }
      }
    })
  }
}
